import Skeleton from "react-loading-skeleton";

import styles from "./DashboardViewWidget.module.scss";

type DashboardViewWidgetSkeletonProps = {
  /** height of the widget in React Grid Layout units */
  h: number;
};

export const DashboardViewWidgetSkeleton = ({
  h,
}: DashboardViewWidgetSkeletonProps) => {
  return (
    <div className={styles.widget}>
      <Skeleton height={h * 300 - 24 + 10 * (h - 1)} />
    </div>
  );
};
